<template>
<div class="layout-dialog mkt-ops -main-font">
    <div style="position: absolute;top: 50%; left: 50%; width: 10%; z-index: 7;" v-show="loadData == true">
        <md-progress-spinner :md-stroke="8" :md-diameter="65" md-mode="indeterminate"></md-progress-spinner>
    </div>

    <div class="md-layout -head -update">
        <div class="md-layout-item md-large-size-30 md-medium-size-30 md-small-size-40">
            <md-field class="md-has-value">
                <label>Group Name</label>
                <md-input ref="form_group_name" v-model="value.group_name" class="-font-kanit"></md-input>
            </md-field>
        </div>
        <div class="md-layout-item md-large-size-70 md-medium-size-70 md-small-size-60 checkbox-status">
            <md-checkbox v-model="status" class="md-primary" @change="setActive()">Active</md-checkbox>
        </div>
    </div>
    <div class="md-layout -browse">
        <!-- <div class="md-layout-item md-large-size-35 md-medium-size-35 md-small-size-35"> -->
        <div style="width: 33%">
            <md-button class="md-raised md-primary btn-browser" @click="openDialogCustomer">
                <md-icon>search</md-icon>
                browse
            </md-button>
            <md-button class="md-raised md-button-upload btn-upload" @click="trigger_upload" style="background-color: #A8A8A8 !important;color:white !important;">
                <md-icon style="color:white !important;">file_upload</md-icon>
                upload
            </md-button>
            <input type="file" ref="fileInput" class="browse-file" :accept="accept" @change="browseFile">
        </div>
            <!-- <div class="md-layout-item md-large-size-65 md-medium-size-65 md-small-size-65 search-customer"> -->
            <div class="search-customer" style="width: 67%">
                <md-field class="input-code md-has-value">
                    <label>Customer Code</label>
                    <md-input v-model="customer_code"></md-input>
                </md-field>
                <md-button class="md-primary btn-add" @click="addCustomerByCode()">Add</md-button>
                <md-button class="btn-clear" @click="clearCustomerByCode()">Clear</md-button>
            </div>
        </div>

        <div class="md-layout -showlabel">
            <div class="md-layout-item md-large-size-90 md-medium-size-90 md-small-size-80">
                Customer in group ({{value.customers.length.toLocaleString()}})
            </div>
            <div class="md-layout-item md-large-size-10 md-medium-size-10 md-small-size-20 -icon-back">
                <i class="md-icon material-icons -delete-back" title="Delete" @click="removeItem()">delete_sweep</i>
            </div>
        </div>

        <div id="table-cg-update">
            <div id="divTableHead">
                <div style="width: 7%; padding-left: 5px;">
                    <label class="checkbox-container">
                    <input type="checkbox" v-model="checkAll" name="chk-all" @change="selectAll">
                    <span class="-checkbox-primary"></span>
                    </label>
                </div>
                <div style="width: 11%">Code</div>
                <div style="width: 31%">English Name</div>
                <div style="width: 31%">Thai Name</div>
                <div style="width: 20%; padding-right: 10px;">Price Type</div>
            </div>
            <div id="divTableBody">
                <div :class="'row-bg-gray'" v-for="(item, sIndex) in value.customers" :key="sIndex">
                    <div style="width: 7%; padding-left: 5px;">
                        <label class="checkbox-container">
                        <input v-model="selectedCustomer" type="checkbox" name="chk" :value="item.code">
                        <span class="-checkbox-primary"></span>
                        </label>
                    </div>
                    <div style="width: 11%">{{ item.code }}</div>
                    <div style="width: 31%" class="nowrap-title -font-kanit" :title="item.title">{{ item.title }}</div>
                    <div style="width: 31%" class="nowrap-title -font-kanit" :title="item.title_th">{{ item.title_th }}</div>
                    <div style="width: 20%;  padding-right: 10px;">{{ item.pricetype_code }}</div>
                </div>
            </div>
        </div>

        <dialogCustomer :showDialog="showDialogCustomer" :import=dataImport @onImport="onImportCustomer" @onCancel="onCancelCustomer" @onRemoveItem="onRemoveItem" @onAddItem="onAddItem"></dialogCustomer>
        <md-dialog-alert :md-active.sync="dlgAlert" :md-title=dlgAlertTitle :md-content=dlgAlertDetail />

        <md-snackbar :md-position="position" :md-duration="isInfinity ? Infinity : duration" :md-active.sync="showSnackbar" md-persistent>
            <span>{{ dContent }}</span>
            <md-button class="md-primary" @click="showSnackbar = false">OK</md-button>
        </md-snackbar>

            <dialogTemplate
            :showDialog="showDialogTemplate"
            @onCancel="showDialogTemplate = $event"
            @onImportExcelFile="onImportExcelFile"
            ></dialogTemplate>
            <!-- :productsImport="productsImport" -->

             <dialogImportCustomerExcel
                :showDialog="showDialogExcel"
                @onCancel="showDialogExcel = $event"
                :customers="dataCustomersFromExcel"
                :dataExcel="dataExcel"
                @onImport="onImportFromExcel"
                ></dialogImportCustomerExcel>
            
                <!-- :importedProduct="value.products" -->
    </div>
</template>

<script>
import {
    required,
    minLength
} from "vuelidate/lib/validators";

// import dialogCustomer from "@/components/shared/dialog-import-customer";
import dialogCustomer from "@/components/shared/dialog-browse-customer";
import CipherService from "@/services/cipher";

import CustomerService from "@/services/customer"

// import dialogImport from '@/components/system/customer-group/dlg-import-customer';
import dialogTemplate from '@/components/system/customer-group/dialogTemplate';
import dialogImportCustomerExcel from '@/components/system/customer-group/dialogImportCustomerExcel'

import _ from "lodash";

const toLower = text => {
    return text.toString().toLowerCase();
};

const searchByName = (items, term) => {
    if (term) {
        return items.filter(item => toLower(item.name).includes(toLower(term)));
    }

    return items;
};

export default {
    name: "cusgomer-group-form",
    props: ["value", "action"],
    components: {
        dialogCustomer,
        dialogTemplate,
        dialogImportCustomerExcel
    },
    data() {
        return {
            loadData: false,
            position: "center",
            duration: 20000,
            isInfinity: false,
            dContent: "",
            showSnackbar: false,
            status: true,
            selected: [],
            customer_code: null,
            search: null,
            searched: [],
            selectedCustomer: [],
            dataImport: [], //[{ code: null, title_th: null, bparea_code: null }],
            group_name: "",
            dlgAlert: false,
            dlgAlertTitle: "",
            dlgAlertDetail: "",
            disabledStatus: false,
            checkAll: false,

            showDialogTemplate: false,
            showDialogExcel: false,
            dataCustomersFromExcel: [],
            dataExcel: [],

            showDialogCustomer: false,
            tempCustomer: []
        };
    },
    validations: {
        name: {
            required
        }
    },
    methods: {
        focusGroup(){
            this.$refs.form_group_name.$el.focus();
            this.$refs.form_group_name.$el.select();
        },
        selectAll() {
            console.log(this.checkAll);
            if (this.checkAll) {
                this.selectedCustomer = [];
                for (let i = 0; i < this.value.customers.length; i++) {
                    this.selectedCustomer.push(this.value.customers[i].code);
                }
            } else {
                this.selectedCustomer = [];
            }
        },
        onSelectData(item) {
            if (this.selectedCustomer.length == this.value.customers.length) {
                this.checkAll = true;
            } else {
                this.checkAll = false;
            }
        },
        setActive() {
            if (this.status == true) this.value.status = "active";
            else this.value.status = "inactive";

            // console.log(this.value);
        },
        searchOnTable() {
            this.searched = searchByName(this.users, this.search);
        },
        openDialogCustomer() {
            this.checkAll = false;
            this.loadData = true;
            //console.log("customer", this.value.customers)
            this.dataImport = _.clone(this.value.customers);

            this.showDialogCustomer = true;

            //  console.log("include ", this.dataImport)

            // this.$refs["dlg-customer"].showDialog = true;

            // setTimeout(function () { }, 100);
        },
        trigger_upload() {
            // alert('import');
            this.showDialogTemplate = true;
        },
        accept() {},
        browseFile() {},
        onSelect(items) {
            this.selected = items;
        },
        onImportCustomer(data) {
            //console.log('impot',data);
            this.value.customers = data;
            this.loadData = false;
            this.showDialogCustomer = false;
        },
        onCancelCustomer() {
            this.loadData = false;
            this.showDialogCustomer = false;
        },
        addCustomerByCode() {

            if (this.customer_code == "" || this.customer_code == null) {

                    this.dContent = "Please input code.";
                    this.showSnackbar = true;
                    return;
            }

            let listCustomer = this.customer_code.split(",");

            CustomerService.checkCustomersImport(listCustomer).then(response => {

            // CipherService.getCustomerByCode(this.customer_code).then(response => {
                let customer = response;

                if (customer.length == 0) {

                    this.dContent = "Item not found.";
                    this.showSnackbar = true;
                    return;
                }

                let _self = this;

                customer.forEach(function(el) {
                    let index = _self.value.customers.findIndex(
                    item => item.code === el.code
                    );

                    if (index == -1) {
                        _self.value.customers.push({
                            code: el.code,
                            title: el.title,
                            title_th: el.title_th,
                            area_name: el.area_name,
                            bparea_code: el.bparea_code,
                            bptype_code: el.bptype_code,
                            pricetype_code: el.pricetype_code,
                            status: el.status
                        });
                    }else{
                        _self.dContent = "Duplicate item.";
                        _self.showSnackbar = true;
                        return;
                    }

                    let indexTemp = _self.tempCustomer.findIndex(
                        item => item.code == el.code
                    );
                    if(indexTemp != -1) _self.tempCustomer.splice(indexTemp, 1);

                    _self.value.tempCustomer = _sefl.tempCustomer;

                
                });
                // if (!customer) {
                //     // this.$snack.show({
                //     //     text: "Item not found.",
                //     //     button: "OK"
                //     // });
                //     this.dContent = "Item not found.";
                //     this.showSnackbar = true;
                //     return;
                // }


                this.customer_code = "";
            });
        },
        clearCustomerByCode() {
            this.customer_code = "";
        },
        removeItem() {
            for (var i = 0; i < this.selectedCustomer.length; i++) {
                let index = this.value.customers.findIndex(
                    item => item.code == this.selectedCustomer[i]
                );

                let indexTemp = this.tempCustomer.findIndex(
                    item => item.code == this.selectedCustomer[i]
                );
                if(indexTemp == -1)
                    this.tempCustomer.push(this.value.customers[index])

                this.value.customers.splice(index, 1);

                this.value.tempCustomer = this.tempCustomer;


            }

            this.selectedCustomer = [];
            this.checkAll = false;
        },
        onImportExcelFile(data){
            let customers = [];
            for(let i = 1; i < data.length; i++){
                if(data[i] != ""){
                    customers.push(data[i][0]);
                }
            }

            this.dataExcel = customers;
            // console.log(customers);

            CustomerService.checkCustomersImport(customers)
            .then(res => {
                this.dataCustomersFromExcel = res;
                this.showDialogTemplate = false;
                this.showDialogExcel = true;
            })
            .catch(err => {});

        },
        onImportFromExcel(data){
            let _self = this;
            data.forEach(function(item){
                let idx = _self.value.customers.findIndex(x => x.code === item.code);
                console.log(idx);
                if(idx < 0) 
                    _self.value.customers.push(item)


                let indexTemp = _self.tempCustomer.findIndex(
                    row => row.code == item.code
                );
                if(indexTemp != -1) _self.tempCustomer.splice(indexTemp, 1);

            });
            this.showDialogExcel = false;
        },
        onRemoveItem(customer){

            // console.log(customer);
            // let indexTemp = this.tempCustomer.findIndex(
            //     row => row.code == code
            // );
            // if(indexTemp != -1) this.tempCustomer.splice(indexTemp, 1);
            let indexTemp = this.tempCustomer.findIndex(
                item => item.code == customer.code
            );
            if(indexTemp == -1)
                this.tempCustomer.push(customer)

            this.value.tempCustomer = this.tempCustomer;
        },
        onAddItem(customer)
        {
            let indexTemp = this.tempCustomer.findIndex(
                item => item.code == customer.code
            );
            if(indexTemp != -1) this.tempCustomer.splice(indexTemp, 1);

            this.value.tempCustomer = this.tempCustomer;
        }
    },
    created() {
        this.searched = this.users;

        if (this.value.status == "active") this.status = true;
        else this.status = false;

        if (this.value.active_in_campaign === true) {
            this.dlgAlert = true;
            this.dlgAlertTitle = "Warning!";
            this.dlgAlertDetail = "Customer group is active in the campaign";

            this.disabledStatus = true;
        }
    }
};
</script>

<style lang="scss">
.customer-group-dialog {
    z-index: 8 !important;

    .md-layout {
        &.-browse {
            margin-top: 5px;

            .btn-browser,
            .btn-upload {
                width: 120px;
                height: 32px;
                margin-top: 15px;
                margin-left: 5px;

                .md-button-content {
                    font-size: 14px;
                    padding-right: 3px;

                    .md-icon {
                        margin-right: 3px;
                        font-size: 21px !important;
                    }
                }
            }

            .browse-file {
                display: none;
            }

            .search-customer {
                background: #f7f7f7;
                height: 60px;
                padding-left: 10px;

                .input-code {
                    width: 65%;
                    margin: 3px 35px 0px 10px;
                    display: inline-block;

                    label {
                        font-size: 12px;
                        padding-top: 5px;
                    }

                    input {
                        width: 100% !important;
                        font-size: 12px;
                    }
                }

                button {
                    margin-top: 15px;

                    &.btn-add {
                        min-width: 60px;
                        display: inline-block;
                    }

                    &.btn-clear {
                        min-width: 40px;
                        display: inline-block;
                    }
                }
            }
        }

        &.-showlabel {
            margin-top: 15px;
            font-size: 16px;
            font-weight: 500;
        }

        .-icon-back {
            color: #b3b3b3;
            text-align: right;

            .-delete-back {
                cursor: pointer;
            }
        }
    }

    #table-cg-update {
        .checkbox-container {
            display: block;
            position: relative;
            padding-left: 35px;
            margin-bottom: 12px;
            cursor: pointer;
            font-size: 22px;
            -webkit-user-select: none;
            -moz-user-select: none;
            -ms-user-select: none;
            user-select: none;
        }

        /* Hide the browser's default checkbox */
        .checkbox-container input {
            position: absolute;
            opacity: 0;
            cursor: pointer;
            height: 0;
            width: 0;
        }

        /* Create a custom checkbox */
        .-checkbox-primary {
            position: absolute;
            top: 0;
            left: 0;
            height: 20px;
            width: 20px;
            background-color: #fff;
            border: 2px solid #767676;
        }

        /* On mouse-over, add a grey background color */
        .checkbox-container:hover input~.-checkbox-primary {
            background-color: #ccc;
        }

        /* When the checkbox is checked, add a blue background */
        .checkbox-container input:checked~.-checkbox-primary {
            background-color: #3e51b5;
            border-color: #3e51b5;
        }

        /* Create the -checkbox-primary/indicator (hidden when not checked) */
        .-checkbox-primary:after {
            content: "";
            position: absolute;
            display: none;
        }

        /* Show the -checkbox-primary when checked */
        .checkbox-container input:checked~.-checkbox-primary:after {
            display: block;
        }

        /* Style the -checkbox-primary/indicator */
        .checkbox-container .-checkbox-primary:after {
            left: 6px;
            top: 1px;
            width: 5px;
            height: 13px;
            border: solid white;
            border-width: 0 2px 2px 0;
            -webkit-transform: rotate(45deg);
            -ms-transform: rotate(45deg);
            transform: rotate(45deg);
        }

        #divTableHead {
            width: 99.3%;
            display: -webkit-inline-box;
            font-size: 13px;
            font-weight: bold;
            margin-top: 15px;
            margin-bottom: 10px;

            div {
                // border: 1px solid pink;
                padding-left: 5px;
                padding-right: 5px;

                &.-text-right {
                    text-align: right;
                }

                &.-text-center {
                    text-align: center;
                }
            }
        }

        #divTableBody {
            width: 100%;
            height: calc(80vmin - 325px);
            display: block;
            overflow-y: scroll;
            font-size: 13px;

            >div {
                width: 100%;
                height: 30px;
                display: -webkit-inline-box;
                padding-top: 5px;
                padding-bottom: 5px;

                div {
                    // border: 1px solid pink;
                    padding-left: 5px;
                    padding-right: 5px;

                    &.-text-right {
                        text-align: right;
                    }

                    &.-text-center {
                        text-align: center;
                    }

                    &.nowrap-title {
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }
                }
            }

            .row-bg-gray:hover {
                background: rgba(236, 236, 235, 1);
            }

            &::-webkit-scrollbar {
                height: 7px;
                width: 8px;
            }
        }
    }
}
</style>
